/* eslint-disable @typescript-eslint/ban-types */
import { type RefObject, useState } from 'react';

import { type IDocumento } from '@/interfaces/model/don.interface';
import type { CTNUploadRef, FileUpload } from '@ctn/ui/types/ctn-upload';

/**
 * Hook para gestionar la duplicidad de archivos en un componente de subida de archivos.
 */
export const useFileDuplicate = (refFile: RefObject<CTNUploadRef | null>) => {
	const [message, setMessage] = useState<string | undefined>(undefined);

	const onDuplicatedFile = ({ file, allDocuments }: { file: FileUpload; allDocuments: IDocumento[] }) => {
		const isFindedName = allDocuments.some(
			({ nombre }) => nombre?.trim().toLowerCase() === file.rawFile.name.trim().toLowerCase(),
		);

		if (isFindedName) {
			setTimeout(() => refFile.current?.resetUpload(), 0);
			setMessage('No se ha podido añadir el documento. Ya se encuentra en la solicitud.');
			return true;
		}

		setMessage(undefined);
		return false;
	};

	// Función para limpiar el error manualmente si fuera necesario
	const clearError = () => setMessage(undefined);

	return {
		onDuplicatedFile,
		message,
		clearError,
	};
};
